export default "__VITE_ASSET__DDZv0ki6__"